import { render } from "./LayoutOnboarding.vue?vue&type=template&id=be864196&scoped=true"
import script from "./LayoutOnboarding.vue?vue&type=script&lang=js"
export * from "./LayoutOnboarding.vue?vue&type=script&lang=js"

import "./LayoutOnboarding.vue?vue&type=style&index=0&id=be864196&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be864196"]])

export default __exports__